import IconLogo from "../../../assets/icon/svg/IconLogo";
import useQuery from "../../Hooks/useQuery";

const Header = () => {
   const query = useQuery();
   const returnUrl = query.returnUrl;
   const getUrlBack = () => {
      try {
         const newUrl = new URL(returnUrl);
         return newUrl.origin;
      } catch (error) {
      }
      return false
   }
   return (
      <header className="flex-center">
         <div className="header-container">
            {getUrlBack() ?
               <a href={getUrlBack()}>
                  <IconLogo />
               </a>
               :
               <IconLogo />
            }
         </div>
      </header>
   )
}
export default Header;